// D-1014 (ひろ 2026-10-08 承認): 閉じるボタンを 1 つにする。
//   今まで ✕ / × の字で、箱の大きさが 32〜44px・字の大きさもまちまち(15 通りほど)だった。
//   ★箱は戻る/ホームと同じ 48×48(backButton.js)。中身は CloseIcon(Lucide x)。aria-label は「閉じる」。
//   ★data-testid・onClick・onPointerDown・disabled・ref・style は呼び出し側のものをそのまま渡す(挙動は呼び出し側のまま)。
//   ★テストは字ではなく data-testid か role=button name=閉じる で掴む(D-630)。
import { forwardRef } from 'react'
import { backButtonClass, compactHeaderBackButtonClass } from './backButton'
import { CloseIcon } from './icons/NavIcons'

/**
 * @param {string} tone 色の class(既定 text-muted)。アイコンは currentColor。
 * @param {boolean} compact 1 行の細い帯(バナーなど)向け。箱は 48×48 のまま縦の占有を 32px に(-my-2)。
 * @param {string} label aria-label(既定 閉じる)
 * @param {number} iconSize アイコンの一辺(既定 NAV_ICON_PX)
 */
export const CloseButton = forwardRef(function CloseButton(
  { tone = 'text-muted', compact = false, className = '', label = '閉じる', iconSize, ...rest },
  ref,
) {
  const box = compact ? compactHeaderBackButtonClass(tone) : backButtonClass(tone)
  return (
    <button ref={ref} type="button" aria-label={label} className={`${box} ${className}`.trim()} {...rest}>
      <CloseIcon size={iconSize} />
    </button>
  )
})

